import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M18.5 15.5L22 12L18.5 8.5L17.793 9.207L20.086 11.5H2V12.5H20.086L17.793 14.793L18.5 15.5Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ThinLongRight"
);
